function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "#3DC5CC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 19.817V7.56C27.5 5.73 27.95 5 29.45 5h3.6C34.4 5 35 5.915 35 7.56V32.44c0 1.646-.6 2.378-1.95 2.561h-3.6c-1.2 0-1.8-.732-1.8-2.378-.15-4.39-.15-8.598-.15-12.805zM5 26.05v-6.68c0-1.47.6-1.87 2.25-1.87h3c1.65 0 2.25.4 2.25 2.004v13.492c0 1.47-.6 2.004-2.25 2.004h-3C5.6 35 5 34.466 5 32.996V26.05zM23.75 28.817v4.435c0 1.21-.613 1.613-1.837 1.748H18.24c-1.224 0-1.99-.538-1.99-1.748v-9.139c0-1.075.612-1.613 1.837-1.613h3.826c1.224 0 1.837.538 1.837 1.613v4.704z",
  fill: "#fff"
});

function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgLogoIcon;